import { FormControlLabel } from '@mui/material';
import styled from 'styled-components';

export const Option = styled(FormControlLabel)`
  &.MuiFormControlLabel-root {
    justify-content: flex-start;
  }
`;
